import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ colors, spacing }) => ({
  container: {
    gap: spacing(6),
  },
  section: {
    gap: spacing(2),
  },
  rows: {
    gap: spacing(1),
  },
  actions: {
    gap: spacing(2),
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: spacing(3),
  },
  rowLabel: {
    color: colors.foregroundDefaultMuted,
  },
  rowValue: {
    flexShrink: 1,
    textAlign: "right",
  },
}));

export default stylesheet;
